import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createUygunaKiralaLocationSaga } from "src/store/uygunakirala-locations/saga";
import * as Yup from "yup";

const UygunaKiralaLocationCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("UygunaKiralaLocation.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Name: "",
          Code: "",
          Lat: "",
          Long: "",
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Name: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            createUygunaKiralaLocationSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Code: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("UygunaKiralaLocation.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "Code",
            label: t("UygunaKiralaLocation.Code").toString(),
          },
          {
            field: "Latitude",
            googlemap: {
              latField: "Latitude",
              lonField: "Longitude",
            },
          },
        ]}
      />
    </React.Fragment>
  );
};
export default UygunaKiralaLocationCreateForm;
